module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADgSURBVEhL3ZRBCsJAEAQDfkPBY/6gd8Gf+DbBT0T9Qu56F9R7tHstFjVRQQcPKRiY7Z2t1QRS9IumaTaXJ5St2f4dySq8GWdsx4A3QxwH3gxxHHjvmTr3+wl5H5KcEXfiGdqE5k+qldoyCT7B8Es8Q/uAzh1UwyR5h2ZLD9+OtWGmE51bJsknNDjysOrI2Yz3aVt4Pgm+QYcrF8uE1hPcGbbiwJshjkH/oAeflr+gHz52sYxF4oEey9blnjgOiRcSJ9wTxyFpjd8X1MRxSLrH7wt2xHFIOvcllqtmxL2hKK5dK/S0qQPWGgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-piping/light/24.png
// module id = 2336
// module chunks = 2